/*
 * @Author: your name
 * @Date: 2020-03-20 18:55:01
 * @LastEditTime: 2020-04-16 14:18:57
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \h5_hot_mall\src\config.js
 */

let release = {
    //公用图片路径
    imgPath: 'https://statics.7dingdong.com/static/wx_program_img/integral_mall/', //正式
    // oss图片路径
    ossImgPath:
        'https://7dd-statics.oss-cn-beijing.aliyuncs.com/smallProgram/installMall/',
    //跳转路径
    goPath: 'https://h.7dingdong.com/#/', // 正式
    //接口路径
    Domain: 'https://integral.7dingdong.com/', // 正式

    appletsPath: 'https://7ddapi.7dingdong.com', //

    wxAppId: 'wxcef271c70c3c8428', //正式
    // wx0745ca56932730e0
    //分享图片
    shareImg:
        'https://7dd-statics.oss-cn-beijing.aliyuncs.com/smallProgram/my_store/294bb56d27c1a59f17eedb8c28222d3.jpg'
}
let trail = {
    //公用图片路径
    imgPath: 'https://statics.7dingdong.com/static/wx_program_img/integral_mall/',
    // oss图片路径
    ossImgPath:
        'https://7dd-statics.oss-cn-beijing.aliyuncs.com/smallProgram/installMall/',
    //跳转路径
    goPath: 'http://csmh5.7dingdong.com/#/', // 测试
    //接口路径
    Domain: 'http://tintegral.7dingdong.com/', // 测试

    appletsPath: 'http://csapi.7dingdong.com', //
    //登录接口
    wxAppId: 'wxcef271c70c3c8428', //测试
    //分享图片
    shareImg:
        'https://7dd-statics.oss-cn-beijing.aliyuncs.com/smallProgram/my_store/294bb56d27c1a59f17eedb8c28222d3.jpg'
}

let trail187 = {
    //公用图片路径
    imgPath: 'https://statics.7dingdong.com/static/wx_program_img/integral_mall/',
    // oss图片路径
    ossImgPath:
        'https://7dd-statics.oss-cn-beijing.aliyuncs.com/smallProgram/installMall/',
    //跳转路径

    goPath: 'http://187h.7dingdong.com/#/', // 测试

    //接口路径
    Domain: 'http://187integral.7dingdong.com/', // 测试

    appletsPath: 'https://187ddapi1.7dingdong.com/', //
    //登录接口
    wxAppId: 'wxcef271c70c3c8428', //测试

    //分享图片
    shareImg:
        'https://7dd-statics.oss-cn-beijing.aliyuncs.com/smallProgram/my_store/294bb56d27c1a59f17eedb8c28222d3.jpg'
}

// export default trail187
export default release
//  trail187 测试  4337707  trail
//  release  正式
// 4326648 ,6334907测试店铺正式   4321275 //正式
